import { useEffect, useRef } from "react";
import { Capacitor } from "@capacitor/core";
import { ensureNativeFcmSubscription } from "@/lib/push-subscription";

// Registra o token FCM do aparelho uma vez por sessão autenticada dentro
// do app Android nativo — ver comentário grande em push-subscription.ts
// sobre por que isso NÃO pode depender do toggle "Notificação push no
// celular" de um alerta específico (causa raiz do silêncio total
// reportado 2026-09-09: regra de ignição já tinha channelPush=true desde
// antes do app nativo existir, então o toggle nunca disparava de novo).
//
// Silencioso de propósito: se o usuário negar a permissão do sistema, ou
// o Google Play Services falhar por qualquer motivo, o app continua
// funcionando normalmente (push é reforço, nunca bloqueia nada) — sem
// toast de erro a cada login.
export function useNativePushRegistration(enabled: boolean): void {
  const attemptedRef = useRef(false);

  useEffect(() => {
    if (!enabled || !Capacitor.isNativePlatform() || attemptedRef.current) return;
    attemptedRef.current = true;
    ensureNativeFcmSubscription().catch(() => {
      // Negado/indisponível — tenta de novo na próxima vez que o app
      // autenticar (próximo boot/login), nunca insiste na mesma sessão.
      attemptedRef.current = false;
    });
  }, [enabled]);
}
